import XIcon from '@/assets/icons/X.svg?react'
import TelegramIcon from '@/assets/icons/Telegram.svg?react'
import { Container } from '@/components/ui/template/Container'
import { SlideIn } from '../../../components/ui/transitions/SlideIn'

const SocialNetworkSection = () => (
	<Container className="bg-primary">
		<Container.Content
			className="
					flex justify-center items-center gap-10 text-center flex-col-reverse md:py-8 md:px-[160px] md:gap-[60px] md:text-left md:flex-row leading-[3rem] overflow-hidden"
		>
			<SlideIn from="bottom" className="flex flex-col gap-5 md:gap-[16px] justify-center">
				<h1 className="text-neutral font-bold text-[3.75rem] md:text-[3.75rem] uppercase">
					Follow{' '}
					<a href="https://x.com/PepperChain" target="_blank" className="w-fit self-center md:self-auto">
						Pepper
					</a>{' '}
					to get all the latest spicy news!
				</h1>
				<div className="flex gap-8 justify-center md:justify-start items-center">
					<a href="https://x.com/pepperchain" target="_blank">
						<XIcon className="size-[35px] text-white" />
					</a>
					<a href="https://t.me/officialpeppercoin" target="_blank">
						<TelegramIcon className="size-[35px] text-white" />
					</a>
					<a href="https://www.coingecko.com/en/coins/pepper" target="_blank">
						<img src="/images/coingecko.webp" alt="Coingecko" className="size-[45px]" loading="lazy" />
					</a>
				</div>
			</SlideIn>
			<SlideIn from="top">
				<img
					src="/images/social.webp"
					alt="Pepper Social"
					loading="lazy"
					className="size-[160px] md:size-[200px] max-w-none"
				/>
			</SlideIn>
		</Container.Content>
	</Container>
)

export default SocialNetworkSection
